const CART_NOTE_KEY = "cart_order_note";

/* Save note → localStorage + Shopify cart */
function saveCartNote(value) {
  localStorage.setItem(CART_NOTE_KEY, value);

  fetch(`${routes.cart_update_url}`, {
    ...fetchConfig(),
    body: JSON.stringify({ note: value })
  });
}

/* Restore note → textarea only (no Shopify fetch — saving is saveCartNote's job) */
function restoreCartNote() {
  const textarea = document.getElementById("CartDrawer-note");
  if (!textarea) return;
  if (document.activeElement === textarea) return;

  const saved = localStorage.getItem(CART_NOTE_KEY);
  if (saved === null) return;

  if (textarea.value !== saved) {
    textarea.value = saved;
  }
}

/* Input listener */
document.addEventListener("input", function (e) {
  if (e.target?.id === "CartDrawer-note") {
    saveCartNote(e.target.value);
  }
});

/* Restore on page load and whenever the cart drawer re-renders */
document.addEventListener("DOMContentLoaded", restoreCartNote);
document.addEventListener("cart-drawer:refresh", restoreCartNote);



// Assumes debounce(), fetchConfig(), routes, and ON_CHANGE_DEBOUNCE_TIMER exist globally
// class DrawerCartNote extends HTMLElement {
//   constructor() {
//     super();
    

//     this.textarea = this.querySelector("#CartDrawer-note");
//     this.saveBtn  = this.querySelector(".giftnote__save");

//     // Clean up legacy popup bits if they exist in the DOM
//     this.querySelector(".giftnote__drawercart__addnote")?.remove();
//     this.querySelector(".giftnote__body__close")?.remove();
//     this.querySelector(".giftnote__overlay")?.remove();

//     // Remove tabindex="-1" so elements are naturally focusable
//     this.querySelectorAll("[tabindex='-1']").forEach((el) => el.removeAttribute("tabindex"));

//     this.init();
//   }

//   saveNote() {
//     if (!this.textarea) return;
//     const body = JSON.stringify({ note: this.textarea.value });
//     fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
//   }

//   init() {
//     if (this.textarea) {
//       // Autosave as user types (debounced)
//       this.textarea.addEventListener(
//         "input",
//         debounce(() => this.saveNote(), ON_CHANGE_DEBOUNCE_TIMER)
//       );
//     }

//     if (this.saveBtn) {
//       this.saveBtn.addEventListener("click", (e) => {
//         e.preventDefault();
//         this.saveNote();
//       });
//     }
//   }
// }

// customElements.define("drawer-cart-note", DrawerCartNote);
